import { render, staticRenderFns } from "./CardBox.vue?vue&type=template&id=0d5f07ec&scoped=true"
import script from "./CardBox.vue?vue&type=script&lang=js"
export * from "./CardBox.vue?vue&type=script&lang=js"
import style0 from "./CardBox.vue?vue&type=style&index=0&id=0d5f07ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f07ec",
  null
  
)

export default component.exports